import { Paginated } from 'types/api';

import { instance } from 'utils/api';

// Wire shape is snake_case (BE payload mapper), rows scoped to the doctor.
export type DicomShareRow = {
  id: number;
  file: string;
  name?: string | null;
  password: string;
  redirect_url: string;
  session_id: string;
};

export const fetchDicomShares = async (params: {
  page?: number;
  limit?: number;
}): Promise<Paginated<DicomShareRow>> => {
  const res = await instance.get<Paginated<DicomShareRow>>('dicom-shares', {
    params
  });

  return res.data;
};

export const createDicomShare = async (payload: {
  file: string;
  name?: string;
}): Promise<DicomShareRow> => {
  const res = await instance.post<DicomShareRow>('dicom-shares', payload);

  return res.data;
};

export const deleteDicomShare = (id: number) =>
  instance.delete(`dicom-shares/${id}`);
